import DocumentUploadComponent from "../Components/DocumentUpload/DocumentUploadComponent"

function DocumentUploadPage() {
    return (
        <DocumentUploadComponent/>
    )
}

export default DocumentUploadPage